<template>
    <div class="wui-container lifestyle-list">
        <div class="header">
            <div class="tag-info">
                <span class="tag-name">#{{tag.name}}</span>
                <div class="tag-views">{{tag.total_views}} 浏览</div>
            </div>

            <div class="tag-list">
                <div class="tag-item" 
                    :class="{'tag-active': sort == 'weight'}"
                    @click="selectSort('weight')">最热</div>
                <div class="tag-item" 
                    :class="{'tag-active': sort == 'time'}"
                    @click="selectSort('time')">最新</div>
            </div>
        </div>

        <!-- 列表 -->
        <van-list
            v-model:loading="loading"
            :finished="finished"
            :loading-text="$t('加载中')"
            @load="onLoad"
        >
            <div class="list">
                <div class="list-col left">
                    <LifestyleItem v-for="item in leftList" :key="item.id" :info="item"></LifestyleItem>
                </div>
                <div class="list-col right">
                    <LifestyleItem v-for="item in rightList" :key="item.id" :info="item"></LifestyleItem>
                </div>
            </div>
        </van-list>

        <HomeButton></HomeButton>
    </div>
</template>

<script>
import { List } from 'vant';

import api from "@/api/index";
import LifestyleItem from "@/components/LifestyleItem.vue";
import HomeButton from "@/components/HomeButton.vue";
import { initWechatJSSDK } from "@/assets/wechat.js"

export default {
    components: {
        VanList: List,
        LifestyleItem,
        HomeButton
    },
    data() {
        return {
            pn: 0,
            ps: 20,
            loading: false,
            finished: false,
            leftHeight: 0,
            rightHeight: 0,
            leftList: [],
            rightList: [],
            tag: {
                name: this.$route.query.tag
            },
            sort: 'weight',
        };
    },
    mounted() {
        initWechatJSSDK({
            title: 'Wellcee · Lifestyle',
            desc: this.$t('Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢'),
            imgUrl: 'https://qnimg1.wellcee.com/app.png'
        });
    },
    methods: {
        // 加载
        onLoad(){
            if (this.finished) {
                return false;
            }
            this.pn++;
            this.getLifestyleList();
        },
        // 刷新
        onRefresh(){
            window.scrollTo(0,0);
            this.pn = 1;
            this.loading = true;
            this.finished = false;
            this.leftHeight = 0;
            this.rightHeight = 0;
            this.leftList = [];
            this.rightList = [];
            this.getLifestyleList();
        },
        // 获取Lifestyle列表
        getLifestyleList() {
            let params = {
                page: this.pn,
                count: this.ps,
                order: this.sort || "weight",
                tag_name: decodeURIComponent(this.$route.query.tag)
            };
            
            api.lifestyle.getByTag(params).then(res => {
                let data = res.data.list;
                this.tag = res.data.tag;

                let leftHeight = this.leftHeight;
                let rightHeight = this.rightHeight;
                let leftList = this.leftList;
                let rightList = this.rightList;

                data.forEach(item => {
                    item.width = item.cover.width;
                    item.height = item.cover.height;

                    if (item.height / item.width > 1) {
                        item.rectangle = true;
                    }
                    if (rightHeight >= leftHeight) {
                        leftList.push(item);
                        if (item.rectangle) {
                            leftHeight += 1.5;
                        } else {
                            leftHeight += 1;
                        }
                    } else {
                        rightList.push(item);
                        if (item.rectangle) {
                            rightHeight += 1.5;
                        } else {
                            rightHeight += 1;
                        }
                    }
                });
                if (data.length < this.ps) {
                    this.finished = true;
                }
                
                this.leftHeight = leftHeight;
                this.rightHeight = rightHeight;
                this.leftList = leftList;
                this.rightList = rightList;
                this.$nextTick(()=>{
                    this.loading = false;
                })
            });
        },
        // 选择标签
        selectSort(sort) {
            this.sort = sort;
            this.onRefresh();
        },
    },
};
</script>

<style scoped>

.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    z-index: 1000;
    max-width: 500px;
    margin: 0 auto;
}
.tag-info{
    display: flex;
}
.tag-info .tag-name{
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #111111;
    margin-right: 15px;
}
.tag-info .tag-views{
    font-size: 14px;
    line-height: 20px;
    color: #666;
}


.header .tag-list {
    display: flex;
}

.header .tag-item {
    display: flex;
    align-items: center;
    padding: 0 7px;
    height: 26px;
    background: rgba(17, 17, 17, 0.03);
    border-radius: 6px;
    margin-right: 15px;
    margin-top: 12px;

    font-size: 14px;
    color: #111111;
    white-space: nowrap;
}

.header .tag-active {
    color: rgba(45, 182, 180, 1);
    background: rgba(45, 182, 180, 0.05);
}

.list {
    display: flex;
    align-items: flex-start;
    padding: 100px 15px 20px 15px;
}
.list .list-col {
    width: 50%;
    overflow: hidden;
}
.list .left {
    margin-right: 13px;
}
</style>
